import { KlusModel } from "@personeel/models/KlusModel.ts";
import { KlusSoortModel } from "@personeel/models/KlusSoortModel.ts";
import { DateTime } from "luxon";

export function isEindLocatieAnders(klusSoort?: KlusSoortModel) {
  if (!klusSoort) {
    return false;
  }
  return klusSoort.klusType === "BEWEGINGSGEBONDEN" || klusSoort.klusCode == "TAXI";
}

export function isKlusEindLocatieAnders(klus: KlusModel, klusSoorten: KlusSoortModel[]) {
  if (klus.dienstregelpuntEind + klus.spoorEind !== klus.dienstregelpuntStart + klus.spoorStart) {
    return true;
  }
  const klusSoort = klusSoorten.find((werk) => werk.klusCode == klus.klusSoort);
  return isEindLocatieAnders(klusSoort);
}

export interface SortState {
  properties: (keyof KlusModel)[];
  order: string;
}

export function arraysAreEqual<T>(a?: T[] | null, b?: T[] | null): boolean {
  if (!a || !b) return false;
  if (a.length !== b.length) return false;
  return a.every((val, index) => val === b[index]);
}

export function compareKlussenBySortState(sortState: SortState) {
  return (klusA: KlusModel, klusB: KlusModel) => {
    const properties = sortState.properties;

    let aValue: string | number | DateTime<true> | DateTime<false> | null | undefined;
    let bValue: string | number | DateTime<true> | DateTime<false> | null | undefined;
    if (properties.length == 1) {
      aValue = klusA[properties[0]];
      bValue = klusB[properties[0]];
    } else {
      // Bij gecombineerde kolommen (bijv. start- en eindlocatie) worden de waarden geconcateneerd tot één string.
      aValue = properties.map((k) => (klusA[k] == null ? "" : klusA[k].toString())).join();
      bValue = properties.map((k) => (klusB[k] == null ? "" : klusB[k].toString())).join();
    }
    // datums zijn altijd gevuld
    if (aValue instanceof DateTime && bValue instanceof DateTime) {
      aValue = aValue.toMillis();
      bValue = bValue.toMillis();
    }
    // string properties hoeven niet altijd gevuld te zijn
    if (typeof aValue === "string" || typeof bValue === "string") {
      aValue = aValue?.toString() ?? "";
      bValue = bValue?.toString() ?? "";
      return sortState.order === "asc"
        ? aValue.localeCompare(bValue)
        : bValue.localeCompare(aValue);
    } else if (typeof aValue === "number" && typeof bValue === "number") {
      return sortState.order === "asc" ? aValue - bValue : bValue - aValue;
    }
    return 0;
  };
}
